import React, { useEffect, useMemo, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Tooltip } from 'react-tooltip'
import { PMS_ADMIN } from '../../utilities';


let brandLogo = "./images/BBIL_logo.svg"


const NavBarLeft = ({children}) => {
    const [activeItem, setActiveItem] = useState()

    const location = useLocation();
    const handleClick = (image, index) => {
      setActiveItem(image.url); 
    }

 
    const activeImageList = useMemo(
      () =>[
      { url:'/pmsadmindashboard', src: './images/icons/home.svg',active: './images/icons/home_active.svg', alt: 'PMS Dashboard' },
      { url:'/pmsadminlistofsubjects',src: './images/icons/subjects.svg',active: './images/icons/subjects_active.svg', alt: 'Adverse Events of Subjects' },
      // { url:'/pmssubjectsreview', src: './images/icons/user_one.svg', active: './images/icons/user_one_active.svg', alt: 'Subject List' },
      { url:'/pmssubjectsreview', src: './images/icons/subjects_review.svg', active: './images/icons/subjects_review_active.svg', alt: 'Subjects Review' },
      { url:'/pilist', src: './images/icons/shield.svg', active: './images/icons/shield_active.svg', alt: 'Principal Investigator' },
      { url:'/pmsadminmarketingheadlist', src: './images/icons/user_reg.svg',active: './images/icons/user_reg_active.svg', alt: 'Marketing Head' },
      { url:'/pmsstudydetails', src: './images/icons/registration.svg',active: './images/icons/registration_active.svg', alt: 'Studies' },
      { url:'/pmsadverseeventbank',src: './images/icons/study.svg',active: './images/icons/study_active.svg', alt: 'Adverse Event Master' },
      { url:'/qrlist', src: './images/icons/qr.svg', active: './images/icons/qr_active.svg', alt: 'Quality Reviewer' },
      { url:'/mrlist', src: './images/icons/mr.svg', active: './images/icons/mr_active.svg', alt: 'Medical Reviewer' },
      { url:'/pmssitedetails', src: './images/icons/Sites.svg', active: './images/icons/Sites_active.svg', alt: 'Sites' },
      { url:'/pistudysitemapping', src: './images/icons/mapping.svg', active: './images/icons/mapping_active.svg', alt: 'PI Site and study mapping' },
      {url:'/pmsallreports',src:'./images/icons/graph_up.svg',active: './images/icons/graph_up_active.svg',alt: 'Reports' },
      {url:'/pmsciomsreports',src:'./images/icons/changeLogger.svg',active: './images/icons/changeLoggerActive.svg',alt: 'Cioms reports' },
      {url:'/pmschangelogger2',src:'./images/icons/View.svg',active: './images/icons/ViewActive.svg',alt: 'Audit Trail' },
      {url:'/pmsusermanual',src:'./images/icons/User_manuals.svg',active: './images/icons/User_manuals.svg',alt: 'User Manuals' },

    ],  [] );
    const currentUrl = window.location.pathname;
    useEffect(() => {
    setActiveItem(location.pathname)
      const activeMenuItem = activeImageList.find((item) => item.url === currentUrl);
      if (activeMenuItem ) {
          setActiveItem(activeMenuItem.url);
      }
       else if(currentUrl ==='/pmsnewstudysetup'){
        setActiveItem('/pmsstudydetails')
      }
       else if(currentUrl ==='/pmsadminaddqr' || currentUrl ==='/editqualityreviewer'){
         
        setActiveItem('/qrlist')
      }

       else if(currentUrl ==='/pmsadminaddmr' || currentUrl ==='/editmedicalreviewer'){
         
        setActiveItem('/mrlist')
      }
      
       else if(currentUrl ==='/pmsadminaddpi' || currentUrl === '/editprincipalinvestigator'){
       
         
        setActiveItem('/pilist')
      }
       else if(currentUrl ==='/pmsadminmarketinghead' || currentUrl === '/editmarketingHead'){
         
        setActiveItem('/pmsadminmarketingheadlist')
      }
  },[activeImageList, activeItem, currentUrl]);

  const [isExpand, setIsExpand ] = useState(false)
  const handleMouseEnter=()=>{
    if(window.screen.width>720){
          setIsExpand(true)
        }
 }
 const handleMouseExit=()=>{
  setTimeout(() =>{
    setIsExpand(false)
  }, 500)
 }

    return (
        <div>
          <div className="navLeft" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseExit}>
          <div style={{height:"68px", borderBottom: "2px solid #eaeaea"}}><img src={brandLogo} alt="" className=" brand_logo_pms" /></div>
          <hr className='m-0'/>
          <LeftNavBarBody handleClick={handleClick} isExpand={isExpand} data={activeImageList} activeItem={activeItem} className={"naviconstyl "} activeclass ="naviconstylActivePms"/>
          
                </div>
                <main>{children}</main>
        </div>
    );
};

export default NavBarLeft;

export const PIFlowLeftNavBar = () => {
  const [activeItem, setActiveItem] = useState('');
  const [isExpand, setIsExpand ] = useState(false)
  const location = useLocation();
  const handleMouseEnter=()=>{
    if(window.screen.width>720)
    {   setIsExpand(true)}
     
 }
 const handleMouseExit=()=>{
  setTimeout(() =>{
    setIsExpand(false)
  }, 300)
 }

 const handleClick = (image, index) => {
   setActiveItem(image.url); 
 }
  const activeImageList = useMemo(
    () => [
      { url: '/pidashboard', src: './images/icons/home.svg', active: './images/icons/home_active.svg', alt: 'Dashboard' },
      { url: '/pisubjectslist', src: './images/icons/subjects.svg', active: './images/icons/subjects_active.svg', alt: 'Subject List' },
      //{ url: '/reviewrejectedevents', src: './images/icons/qr.svg', active: './images/icons/qr_active.svg', alt: 'Rejected Events List' },
      { url: '/pirejectedevents', src: './images/icons/shield.svg', active: './images/icons/shield_active.svg', alt: 'Event Clarifications' },
      { url: '/rejectedsubjects', src: './images/icons/qr.svg', active: './images/icons/qr_active.svg', alt: 'Subject Clarifications' },
      {url:'/piusermanual',src:'./images/icons/User_manuals.svg',active: './images/icons/User_manuals.svg',alt: 'User Manuals' }
    ],
    []
  );

  const currentUrl = window.location.pathname;
  useEffect(() => {
    setActiveItem(location.pathname)
    const activeMenuItem = activeImageList.find((item) => item.url === currentUrl);
    if (activeMenuItem) {
      setActiveItem(activeMenuItem.url);
    } 
    else if (currentUrl === '/subjectregistration' || currentUrl === '/updateAEDetails') {
      const dashboardImage = activeImageList.find((item) => item.url === '/pisubjectslist');
      if (dashboardImage) {
        setActiveItem(dashboardImage.url);
      }
    }
    else if (currentUrl === '/pirejectedevents' || currentUrl === "/pirejectedeventsedit"){
      const dashboardImage = activeImageList.find((item) => item.url === '/pirejectedevents');
      if (dashboardImage) {
        setActiveItem(dashboardImage.url);
      }
    }
    else if (currentUrl === '/rejectedsubjects' || currentUrl === "/rejectedsubjedit"){
      const dashboardImage = activeImageList.find((item) => item.url === '/rejectedsubjects');
      if (dashboardImage) {
        setActiveItem(dashboardImage.url);
      }
    }
    else if (currentUrl === '/addnewaetosubject' || currentUrl==='/addnewdosetosubject') {
      const dashboardImage = activeImageList.find((item) => item.url === '/pisubjectslist');
      if (dashboardImage) {
        setActiveItem(dashboardImage.url);
      }
    }
    else if (currentUrl==='/addnewadverseevent') {
      const dashboardImage = activeImageList.find((item) => item.url === '/pisubjectslist');
      if (dashboardImage) {
        setActiveItem(dashboardImage.url);
      }
    }
  }, [activeImageList, currentUrl]);


const [checkUrl, setCheckUrl] = useState(false)
useEffect(() => {
  if(currentUrl ==='/pisubjectslist'||
  currentUrl ==='/pidashboard'||
  currentUrl ==='/pirejectedevents'||
  currentUrl ==='/rejectedsubjects'){
    setCheckUrl(true)
  }
}, [checkUrl, currentUrl])

  return (
    <div className={`navLeft ${checkUrl?'':'subj_reg_mbl'}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseExit}>
        <img src={brandLogo} alt="" className=" brand_logo brndclsformbl" />

        <LeftNavBarBody activeclass={"naviconstylActiveOther "} handleClick={handleClick} isExpand={isExpand} data={activeImageList} activeItem={activeItem} className={"pt-3"}/>

    </div>
  );
};


export const MarketingHeadFlow = () => {
  const [activeItem, setActiveItem] = useState('');
  const [isExpand, setIsExpand ] = useState(false)
  const location = useLocation();

  const handleClick = (image, index) => {
    setActiveItem(image.url); 
  }
  const handleMouseEnter=()=>{
    if(window.screen.width>720)
    {   setIsExpand(true)}
     
 }
 const handleMouseExit=()=>{
  setTimeout(() =>{
    setIsExpand(false)
  }, 300)
 }
  const activeImageList = useMemo(
    () => [
      { url: '/mhdashboard', src: './images/icons/home.svg', active: './images/icons/home_active.svg', alt: 'Dashboard' },
      { url: '/mhsubjectlist', src: './images/icons/mr.svg', active: './images/icons/mr_active.svg', alt: 'Adverse Events of Subjects' },
      { url: '/marketingstafflist', src: './images/icons/subjects.svg', active: './images/icons/subjects_active.svg', alt: 'Marketing Staff' },
      { url: '/mhaddstaff', src: './images/icons/shield.svg', active: './images/icons/shield_active.svg', alt: 'Add Marketing Staff' },
      { url:'/mhsitesdetails', src: './images/icons/Sites.svg', active: './images/icons/Sites_active.svg', alt: 'Site Information' },
      {url:'/marketingheadusermanual',src:'./images/icons/User_manuals.svg',active: './images/icons/User_manuals.svg',alt: 'User Manuals' }
    ],
    []
  );

  const currentUrl = window.location.pathname;
  useEffect(() => {
    setActiveItem(location.pathname)
    const activeMenuItem = activeImageList.find((item) => item.url === currentUrl);
    if (activeMenuItem) {
      setActiveItem(activeMenuItem.url);
    } 
    // else if (currentUrl === '/subjectregistration') {
    //   const dashboardImage = activeImageList.find((item) => item.url === '/pisubjectslist');
    //   if (dashboardImage) {
    //     setActiveItem(dashboardImage.url);
    //   }
    // }
    // else if (currentUrl === '/addnewaetosubject' || currentUrl==='/addnewdosetosubject') {
    //   const dashboardImage = activeImageList.find((item) => item.url === '/pisubjectslist');
    //   if (dashboardImage) {
    //     setActiveItem(dashboardImage.url);
    //   }
    // }
  }, [activeImageList, currentUrl]);


  return (
    <div className="navLeft" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseExit}>
        <img src={brandLogo} alt="" className=" brand_logo" />
<LeftNavBarBody handleClick={handleClick} activeclass={"naviconstylActiveOther"} isExpand={isExpand} data={activeImageList} activeItem={activeItem} className={"pt-3"}/>
    </div>
  );
};



export const QRFlowLeftNavBar = () => {
  const [activeItem, setActiveItem] = useState('');
  const [isExpand, setIsExpand ] = useState(false)
  const location = useLocation();

  const handleClick = (image, index) => {
    setActiveItem(image.url); 
  }

  const handleMouseEnter=()=>{
    if(window.screen.width>720)
    {   setIsExpand(true)}
     
 }
 const handleMouseExit=()=>{
  setTimeout(() =>{
    setIsExpand(false)
  }, 300)
 }
  const activeImageList = useMemo(
    () => [
      { url: '/qrdashboard', src: './images/icons/home.svg', active: './images/icons/home_active.svg', alt: ' Quality Reviewer Dashboard' },
      { url: '/qrsubjectreview', src: './images/icons/qr.svg', active: './images/icons/qr_active.svg', alt: 'Subjects Review' },
      { url: '/reviewlist', src: './images/icons/subjects.svg', active: './images/icons/subjects_active.svg', alt: 'Event Review List' },
      {url:'/qrusermanual',src:'./images/icons/User_manuals.svg',active: './images/icons/User_manuals.svg',alt: 'User Manuals' }
    ],
    []
  );

  const currentUrl = window.location.pathname;
  useEffect(() => {
    setActiveItem(location.pathname)
    const activeMenuItem = activeImageList.find((item) => item.url === currentUrl);
    if (activeMenuItem) {
      setActiveItem(activeMenuItem.url);
    }
  }, [activeImageList, currentUrl]);
   

  return (
    <div className="navLeft" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseExit}>
      <img src={brandLogo} alt="" className=" brand_logo brndclsformbl" />
      <LeftNavBarBody handleClick={handleClick} activeclass={"naviconstylActiveOther"} isExpand={isExpand} data={activeImageList} activeItem={activeItem} className={"pt-3"} />
    </div>
  );
};


export const MarketingStaffFlow = () => {
  const [activeItem, setActiveItem] = useState('');
  const [isExpand, setIsExpand ] = useState(false)
  const location = useLocation();

  const handleMouseEnter=()=>{
    if(window.screen.width>720)
    {   setIsExpand(true)}
     
 }
 const handleMouseExit=()=>{
  setTimeout(() =>{
    setIsExpand(false)
  }, 300)
 }
  const activeImageList = useMemo(
    () => [
      { url: '/marketingstaffdashboard', src: './images/icons/home.svg', active: './images/icons/home_active.svg', alt: 'Dashboard' },
      { url: '/marketingstaffsubjectlist', src: './images/icons/subjects.svg', active: './images/icons/subjects_active.svg', alt: 'Subject List' },
      {url:'/marketingstaffusermanual',src:'./images/icons/User_manuals.svg',active: './images/icons/User_manuals.svg',alt: 'User Manuals' }

    ],
    []
  );

  const currentUrl = window.location.pathname;
  useEffect(() => {
    setActiveItem(location.pathname)
    const activeMenuItem = activeImageList.find((item) => item.url === currentUrl);
    if (activeMenuItem) {
      setActiveItem(activeMenuItem.url);
    } 
    // else if (currentUrl === '/subjectregistration') {
    //   const dashboardImage = activeImageList.find((item) => item.url === '/pisubjectslist');
    //   if (dashboardImage) {
    //     setActiveItem(dashboardImage.url);
    //   }
    // }
    // else if (currentUrl === '/addnewaetosubject' || currentUrl==='/addnewdosetosubject') {
    //   const dashboardImage = activeImageList.find((item) => item.url === '/pisubjectslist');
    //   if (dashboardImage) {
    //     setActiveItem(dashboardImage.url);
    //   }
    // }
  }, [activeImageList, currentUrl]);

  const handleClick = (image, index) => {
    setActiveItem(image.url); 
  }

  return (
    <div className="navLeft" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseExit}>
        <img src={brandLogo} alt="" className=" brand_logo brndclsformbl" />

    <LeftNavBarBody handleClick={handleClick} activeclass={"naviconstylActiveOther"} isExpand={isExpand} data={activeImageList} activeItem={activeItem} className={"pt-3"}/>
    </div>
  );
};

export const MedicalReviewerFlow = () => {
  const [activeItem, setActiveItem] = useState('');
  const [isExpand, setIsExpand ] = useState(false)
  const location = useLocation();

  const handleMouseEnter=()=>{
    if(window.screen.width>720)
    {   setIsExpand(true)}
     
 }
 const handleMouseExit=()=>{
  setTimeout(() =>{
    setIsExpand(false)
  }, 300)
 }
  const activeImageList = useMemo(
    () => [
      { url: '/mrdashboard', src: './images/icons/home.svg', active: './images/icons/home_active.svg', alt: 'MR Dashboard' },
      { url: '/mrreviewlist', src: './images/icons/subjects.svg', active: './images/icons/subjects_active.svg', alt: 'Event Review List' },
      {url:'/mrusermanual',src:'./images/icons/User_manuals.svg',active: './images/icons/User_manuals.svg',alt: 'User Manuals' }
      
    ],
    []
  );
  const handleClick = (image, index) => {
    setActiveItem(image.url); 
  }
  const currentUrl = window.location.pathname;
  useEffect(() => {
    setActiveItem(location.pathname)
    const activeMenuItem = activeImageList.find((item) => item.url === currentUrl);
    if (activeMenuItem) {
      setActiveItem(activeMenuItem.url);
    } 
    // else if (currentUrl === '/subjectregistration') {
    //   const dashboardImage = activeImageList.find((item) => item.url === '/pisubjectslist');
    //   if (dashboardImage) {
    //     setActiveItem(dashboardImage.url);
    //   }
    // }
    // else if (currentUrl === '/addnewaetosubject' || currentUrl==='/addnewdosetosubject') {
    //   const dashboardImage = activeImageList.find((item) => item.url === '/pisubjectslist');
    //   if (dashboardImage) {
    //     setActiveItem(dashboardImage.url);
    //   }
    // }
  }, [activeImageList, currentUrl]);
 

  return (
    <div className="navLeft" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseExit}>
        <img src={brandLogo} alt="" className=" brand_logo" />

        <LeftNavBarBody handleClick={handleClick} activeclass={"naviconstylActiveOther"} isExpand={isExpand} data={activeImageList} activeItem={activeItem} className={"pt-3"}/>

    </div>
  );
};

const LeftNavBarBody = ({activeclass, handleClick, data, activeItem, className}) => {
 

  return (

      <div className="nav_icons">
      <div  >
        <div className={`${localStorage.role_code == PMS_ADMIN?'left_icons' : " left_icons_PI"} `}
        
        >
          {data.map((image, index) => (
            <Link key={index} to={image.url} className='text-decoration-none bg-white' onClick={() => handleClick(image, index)}>
            <div className="image-container">
              <div style={{width:localStorage.role_code == PMS_ADMIN ?"64px":"55px"}}>
                <img
                  key={index}
                  src={image.src}
                  alt={image.alt}
                  data-tooltip-id={image.alt}
                  data-tooltip-content={image.alt}
                  className={activeItem === image.url ? activeclass : className}
                  title={image.alt}
                  
                />
              </div>
              
                <span className={`${activeItem === image.url ? "fw-bold":""} image-text desktop-view ${localStorage.role_code == PMS_ADMIN?'' : " pt-3"} `}
               >{image.alt}</span>
               
           
               <div className='new_hide'>
               <span className={`image-text ${localStorage.role_code == PMS_ADMIN?'' : " pt-3"} `}
               >{image.alt}</span>
               </div>

         
                <div>
               </div>
        </div>
              {/* <Tooltip id={image.alt} style={{ marginTop:"20px" }}/> */}
            </Link>
          ))}
        </div>
      </div>
      </div>
    
  );
};

 

